export default __webpack_public_path__ + "static/media/company.4df909c4.png";